import {FC} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {IMAGES_URL} from "modules/constants";
import {getAvatarImage} from "modules/selectors";

const ImgContainer = styled.div`
	background: #545456;
	border-radius: 50%;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;

const Img = styled.img`
	width: 70%;
	height: 70%;
	object-fit: contain;
`;

export const Avatar: FC = () => {
	const avatar = useSelector(getAvatarImage);

	return (
		<ImgContainer>{avatar && <Img src={`${IMAGES_URL}image/${avatar}`} alt="" />}</ImgContainer>
	);
};
